// extracted by mini-css-extract-plugin
export default {"section":"AgentRegister_section__Zj9Lg","header":"AgentRegister_header__NNG3E","active":"AgentRegister_active__DVekD"};